import { render, staticRenderFns } from "./topic_list.vue?vue&type=template&id=9f77f5ba&scoped=true"
import script from "./topic_list.vue?vue&type=script&lang=js"
export * from "./topic_list.vue?vue&type=script&lang=js"
import style0 from "./topic_list.vue?vue&type=style&index=0&id=9f77f5ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f77f5ba",
  null
  
)

export default component.exports